import React from 'react';

// Routing
import { Switch, Route } from "react-router-dom";

// Import Screens(high level components)

import NotFound from '../screens/NotFound';
import Thinking from '../screens/Thinking/Thinking';
import Services from '../screens/Services/Services';
import Expertise from '../screens/Expertise/Expertise';
import People from '../screens/People/People';
import Network from '../screens/Network/Network';
import News from '../screens/News/News';
import Privacy from '../screens/Privacy/Privacy';
import GDPR from '../screens/GDPR/GDPR';
import REP from '../screens/RealEyesPrivacy/REP';
import RemoveDataForm from '../screens/RemoveDataForm/RemoveDataForm';
import HRAnonHotlineForm from '../screens/HR/HRAnonHotlineForm';
import SuggestionsForm from '../screens/HR/SuggestionsForm';

class Routes extends React.Component {
    render() {
        return (
            <React.Fragment>
                <Switch>
                    <Route exact path="/" component={Thinking} />
                    <Route exact path="/services" component={Services} />
                    <Route exact path="/expertise" component={Expertise} />
                    <Route exact path="/people*" component={People} />
                    <Route exact path="/network" component={Network} />
                    <Route exact path="/news*" component={News} />
                    <Route exact path="/privacy/:id?" component={Privacy} />
                    <Route exact path="/gdpr/:id?" component={GDPR} />
                    <Route exact path="/re-privacy/:id?" component={REP} />
                    <Route exact path="/(ccparequestform|gdprrequestform)" component={RemoveDataForm} />
                    <Route exact path="/hr-anonymous-hotline" component={HRAnonHotlineForm} />
                    <Route exact path="/(suggestion|suggestions)" component={SuggestionsForm} />
                    <Route path="**" component={NotFound} />
                </Switch>
            </React.Fragment>
        );
    }
}

export default Routes;
